/**
 * Main shell — responsive.
 *
 * Desktop (lg+): Header arriba, Sidebar a la izquierda, Main desplazable.
 * Móvil (<lg): Sidebar oculto; barra inferior (MobileTabBar) con 4 favoritos
 * + "Más", que abre el Sidebar como drawer deslizante.
 *
 * Solo se monta para usuarios autenticados (envuelto en <RequireAuth>).
 */
import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { X } from 'lucide-react'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { MobileTabBar } from './MobileTabBar'

export function AppLayout() {
  const [navOpen, setNavOpen] = useState(false)
  const location = useLocation()

  // Cerrar el drawer al cambiar de ruta.
  useEffect(() => {
    setNavOpen(false)
  }, [location.pathname])

  return (
    <div className="h-screen flex flex-col bg-expo-dark">
      <Header />
      <div className="flex flex-1 min-h-0">
        {/* Sidebar fijo — solo desktop */}
        <div className="hidden lg:flex">
          <Sidebar />
        </div>

        {/* Columna principal */}
        <div className="flex-1 min-w-0 flex flex-col">
          {/* Fondo del módulo: blanco. El hombro curvo revela el verde detrás. */}
          <main className="flex-1 min-w-0 overflow-y-auto scrollbar-thin rounded-tl-[32px] lg:rounded-tl-[56px] bg-white">
            <div
              className="w-full"
              style={{ fontFamily: "'Plus Jakarta Sans', 'Archivo', system-ui, -apple-system, sans-serif" }}
            >
              <Outlet />
            </div>
          </main>

          {/* Barra inferior — solo móvil */}
          <MobileTabBar onMore={() => setNavOpen(true)} />
        </div>
      </div>

      {/* Drawer del sidebar — solo móvil */}
      {navOpen && (
        <div className="lg:hidden fixed inset-0 z-[80] flex">
          <div className="absolute inset-0 bg-black/45 animate-overlay-in" onClick={() => setNavOpen(false)} />
          <div className="relative h-full shadow-2xl">
            <Sidebar mobile onNavigate={() => setNavOpen(false)} />
            <button
              type="button"
              onClick={() => setNavOpen(false)}
              aria-label="Cerrar menú"
              className="absolute top-3 right-3 w-9 h-9 rounded-full flex items-center justify-center bg-white/10 hover:bg-white/20 text-white"
            >
              <X size={18} />
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
